import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterJP4: any = null,
    sceneTextLeaveJP4: any = null;
export default function JP4() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterJP4) {
                    AniContainer.removeScene(sceneTextEnterJP4);
                    sceneTextEnterJP4 = null;
                }
                if (sceneTextLeaveJP4) {
                    AniContainer.removeScene(sceneTextLeaveJP4);
                    sceneTextLeaveJP4 = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterJP4 = AniContainer.create({
                    triggerElement: '.dpu-detail-JP4',
                    triggerHook: 1,
                    offset: startH, //textTarget?.offsetHeight,
                    duration: 200, //textTarget?.offsetHeight / 2,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            return () => {
                if (sceneTextEnterJP4) {
                    AniContainer.removeScene(sceneTextEnterJP4);
                    sceneTextEnterJP4 = null;
                }
                if (sceneTextLeaveJP4) {
                    AniContainer.removeScene(sceneTextLeaveJP4);
                    sceneTextLeaveJP4 = null;
                }
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-JP4 dpu-detail-section ${css['dpu-detail-JP4']}`}>
            <div className="img-box">
                <EFPicture src="/responsive/picture/delta-pro-ultra/launch/23.jpg" />
            </div>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secJP4_desc')}</p>
                <h2 className="title">{t('secJP4_title')}</h2>
                <p className="desc">{t('secJP4_desc')}</p>
            </div>
        </section>
    );
}
